import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateField'
})
export class TranslateFieldPipe implements PipeTransform {

  transform(item: any, field: string): string {
    let lang 
    let rtn
    
    try {
      // @ts-ignore
      lang = $localize.locale.split('-')[0]
      rtn = ''   
    
      if(item[field + '_' + lang])
        rtn = item[field + '_' + lang]
      else if(item[field])
        rtn = item[field]
    }
    catch(e){
      //console.log(e) 
    }

    return rtn
  }
}
